import React from 'react'
import { removeItemfromArray } from '../../../functions/lists';

const MultiselectCheckboxSubmenus = ({field, form, ...props}) => (
    <label>
        <input
            {...props}
            {...field}
            type="checkbox"
            checked={form.values[field.name].includes(props.value)}
            onChange={() => {
                if(form.values[field.name].includes(props.value)) {
                    form.setFieldValue(field.name, removeItemfromArray(form.values[field.name], props.value))
                } else {
                    form.values[field.name].push(props.value)
                    form.setFieldValue(field.name, form.values[field.name])
                }
            }}
        />
        <span className="text-small-regular">{props.id}</span>
    </label>
)


export default MultiselectCheckboxSubmenus